module.exports = __webpack_public_path__ + "static/img/keep_benefit_hotel_display.c7384eb8.png";